import LeftSide from "/components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";
import { wrapper } from "../../redux";
import { useSelector } from "react-redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import { setTextCity } from "../../utils";
import EdostMap from "../../components/common/edostMap";
import AllShopsMap from "../../components/common/allShopsMap";
import SdekMap from "../../components/common/sdekMap";
import { fetchAllShops } from "../../redux/action-creaters/contacts";

const SDEK_CITY_BY_HOST = {
  "spb.farkop.ru": "Санкт-Петербург",
  "msk.farkop.ru": "Москва",
};

export default function DeliveryPage({ scripts, host, isBaltex }) {
  const { domainData } = useSelector((state) => state.contacts);
  const { h1, content } = useSelector((state) => state.meta);
  const { cityName } = useSelector((state) => state.location);
  const isRussia = cityName === "Россия";
  const sdekCity = SDEK_CITY_BY_HOST[host];

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title={setTextCity(host, domainData, h1, cityName)}
      >
        <div
          className={"text"}
          dangerouslySetInnerHTML={{
            __html: setTextCity(host, domainData, content, cityName),
          }}
        ></div>

        {/* eslint-disable-next-line no-nested-ternary */}
        {sdekCity ? (
          <SdekMap cityName={sdekCity} isBaltex={isBaltex} />
        ) : isRussia ? (
          <AllShopsMap isBaltex={isBaltex} />
        ) : (
          <EdostMap isBaltex={isBaltex} />
        )}
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    store.dispatch(addBreadcrumb({ link: "/delivery/", name: "Доставка" }));
    await store.dispatch(fetchAllShops(Redis));

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/delivery/",
    );
  }),
);
